var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status)?_c('b-alert',{class:_vm.$style.saleBanner,attrs:{"show":_vm.status}},[(_vm.category)?_c('div',[_c('router-link',{class:_vm.$style.categoryLink,attrs:{"to":{
          name: 'category-page',
          query: { categoryId: _vm.category.id, 'page[number]': 1 },
        }}},[_vm._v(" "+_vm._s(_vm.banner.message)+" ")])],1):_c('div',[_vm._v(" "+_vm._s(_vm.banner.message)+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }